import { h } from 'preact';

import { authStore } from '../../../global-store/subjects/auth';
import { useSubscribe } from '../../hooks/use-subscribe';
import { useRefresh } from '../../hooks/use-refresh';
import { useLoginCard } from '../../hooks/use-login-card';
import { IconArrowLink } from '../../components/1-foundation/icons/icons';

import parselyPropTypes from './prop-types';
import { getDerivedValues } from './getters/get-derived-values';
import { getHandlers } from './getters/get-handlers';

export const ctaAppend = <IconArrowLink modifiers={['arrow-navigation', 'arrow-link', 'c-primary']} />;

const Parsely = ({
  widget,
  htmlProps,
  $root,
  state,
  actions,
  pageActions,
  render,
  isActiveInPage,
  blockInPageType,
  showMoreText,
  showLessText,
  ctaPrimaryLabelInPage,
  confirmInPageMessage,
  parselyCommonState,
  useEffects,
}) => {
  // CUSTOM HOOKS
  useRefresh({
    widgetName: widget.name,
    errorStatus: state.error?.status,
    errorCode: state.error?.code,
  });
  const authState = useSubscribe(authStore);
  const [isLoginCardVisible, toggleLoginCardVisibility, handleLoginCardClose] = useLoginCard(widget.htmlId);

  // DERIVED VALUES
  const derivedValues = getDerivedValues({ state, htmlProps, widget, authState, parselyCommonState });
  const { commonVariables } = derivedValues;

  const isWidgetLoading = state.isLoading || authState.isLoginLoading;

  const modalPrivacyContainer = document.getElementById(widget.modalPrivacyHtmlId);
  const showModalPrivacy =
    authState.isUserLogged &&
    parselyCommonState.showModalPrivacy &&
    widget.htmlId === parselyCommonState.currentWidgetHtmlId;

  // HANDLERS
  const handlers = {
    ...getHandlers({ actions, commonVariables, htmlProps, state, widget, pageActions }),
    handleLoginCardClose,
  };

  useEffects({
    $root,
    authState,
    state,
    actions,
    pageActions,
    commonVariables,
    widget,
    handlers,
    parselyCommonState,
    toggleLoginCardVisibility,
  });

  // RENDERING
  return render({
    state,
    isWidgetLoading,
    derivedValues,
    widget,
    htmlProps,
    authState,
    parselyCommonState,
    handlers,
    isLoginCardVisible,
    isActiveInPage,
    blockType: blockInPageType,
    showMoreText,
    showLessText,
    ctaPrimaryLabelInPage,
    confirmInPageMessage,
    modalPrivacyContainer,
    showModalPrivacy,
  });
};
Parsely.propTypes = parselyPropTypes;

export default Parsely;
